export const STORE_PREFIX = 'ti-bo-store-';
